<cs-challenge-day-cycle-selector
  [displayText]="cycleDisplayText()"
  [animationKey]="animationCounter()"
  [prevDisabled]="isPrevCycleDisabled()"
  [nextDisabled]="isNextCycleDisabled()"
  [loadingDirection]="loadingPrev() ? 'prev' : null"
  (prev)="onPrevCycle()"
  (next)="onNextCycle()"
></cs-challenge-day-cycle-selector>

@if (loading()) {
  <div class="loading-container">
    <oph-loading />
  </div>
} @else {
  <div class="cycles-content" [@slideContent]="animationCounter()">
    <div class="cycles-container">
      @if (selectedCycle()?.level) {
        <!-- Level Card -->
        <div class="level-card">
          <div class="level-header">
            <span class="level-title">{{ stubLevel.name }}</span>
            <div class="streak">
              <span class="streak-count">{{ stubLevel.streak }}</span>
              <span class="streak-bolt">⚡</span>
            </div>
          </div>
          <div class="level-pills">
            @for (completed of stubLevel.progress; track $index) {
              <div
                class="level-pill"
                [class.level-pill--completed]="completed"
                [class.level-pill--current]="$index === stubLevel.currentIndex"
              ></div>
            }
          </div>
        </div>
      }

      <!-- Items Grid -->
      <div class="items-grid">
        @for (item of cycleItems(); track item.name) {
          <button class="item-card" type="button" (click)="onItemClick(item)">
            <div class="item-top-row">
              <img
                class="item-icon"
                [src]="'assets/img/icons/color-icons/' + (item.icon ? item.icon : 'memo') + '.svg'"
                [alt]="item.name"
              />
              <div class="item-meter">
                <svg class="meter-svg" viewBox="0 0 26 26" aria-hidden="true">
                  <circle class="meter-track" cx="13" cy="13" r="10" />
                  <circle
                    class="meter-progress"
                    cx="13"
                    cy="13"
                    r="10"
                    [style.stroke]="item.color"
                    [style.stroke-dasharray]="circumference"
                    [style.stroke-dashoffset]="getMeterDashOffset(item.score)"
                  />
                </svg>
                <span class="meter-value">{{ item.score > 100 ? 100 : item.score }}</span>
              </div>
            </div>

            <oph-metric-bar-chart [dailyScores]="item.dailyScores" [color]="item.color" [barBorderRadius]="4" />

            <div class="item-footer">
              <span class="item-name">{{ item.name }}</span>
            </div>
          </button>
        }
      </div>
    </div>
  </div>
}
